var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCamera = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  className: "camera_svg__lucide camera_svg__lucide-camera"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 13,
  r: 3
})));
export { SvgCamera as ReactComponent };
export default __webpack_public_path__ + "7eddc5d5f2cf2a1231682d1288067ed2.svg";